import { render, staticRenderFns } from "./PublishButton.vue?vue&type=template&id=15a1bb71&scoped=true&"
import script from "./PublishButton.vue?vue&type=script&lang=js&"
export * from "./PublishButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a1bb71",
  null
  
)

export default component.exports